import { SDK_PORTAL_LIST } from '../../shared/Constants';
import * as actionTypes from '../actions/actionTypes';

const initialState = {
    portals: null,
    portalsInfo: null,
    portalInfoCounter: 0,
    addAccountPortal: null,
    message: null,
    superUserMessage: null,
    portalsLoading: true,
    portalInfoLoading: false,
    addingPortal: false
}

export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.FETCH_ACCOUNT_PORTALS_START:
            return {
                ...state,
                portalsLoading: true,
                portalInfoCounter: 0
            }
        case actionTypes.FETCH_ACCOUNT_PORTALS_SUCCESS:
            let sdkPortaList = localStorage.getItem(SDK_PORTAL_LIST)
            return {
                ...state,
                portals: action.portals,
                portalInfoCounter: sdkPortaList ? JSON.parse(sdkPortaList).length - action.noOfDuplicatePortals : 0
            }
        case actionTypes.FETCH_ACCOUNT_PORTALS_FAILURE:
            return {
                ...state,
                portalsLoading: false
            }

        case actionTypes.FETCH_ACCOUNT_PORTAL_INFO_SUCCESS:
            return {
                ...state,
                portalsInfo: {
                    ...state.portalsInfo,
                    [action.portalInfo.portalId]: action.portalInfo
                },
                portalInfoCounter: state.portalInfoCounter+1,
                portalsLoading: !(state.portals.length === state.portalInfoCounter+1)
            }
        case actionTypes.FETCH_ACCOUNT_PORTAL_INFO_FAILURE:
            return {
                ...state,
                error: action.error,
                portalsLoading: false
            }

        case actionTypes.FETCH_ACCOUNT_FARO_ID_START:
            return {
                ...state,
                portalInfoLoading: true
            }
        case actionTypes.FETCH_ACCOUNT_FARO_ID_SUCCESS:
            return {
                ...state,
                portalInfoLoading: false
            }
        case actionTypes.FETCH_ACCOUNT_FARO_ID_FAILURE:
            return {
                ...state,
                portalInfoLoading: false,
                message: {type: "Error", info: {message: "No user found in Optum Bank."}}
            }

        case actionTypes.FETCH_ACCOUNT_GROUP_ID_START:
            return {
                ...state,
                portalInfoLoading: true
            }
        case actionTypes.FETCH_ACCOUNT_GROUP_ID_SUCCESS:
            return {
                ...state,
                portalInfoLoading: false
            }
        case actionTypes.FETCH_ACCOUNT_GROUP_ID_FAILURE:
            return {
                ...state,
                portalInfoLoading: false,
                message: {type: "Error", info: {message: action.error}}
            }

        case actionTypes.SET_DISPLAY_MESSAGE:
            return {
                ...state,
                message: action.message
            }
            
        case actionTypes.SET_SUPER_USER_DISPLAY_MESSAGE:
            return {
                ...state,
                superUserMessage: action.message
            }

        case actionTypes.SET_ADD_ACCOUNT_PORTAL:
            return {
                ...state,
                addAccountPortal: action.portalInfo
            }
        case actionTypes.ADD_ACCOUNT_START:
            return {
                ...state,
                message: null,
                addingPortal: true
            }
        case actionTypes.ADD_ACCOUNT_SUCCESS:
            return {
                ...state,
                addingPortal: false,
                message: {type: "Success", info: {message: "User account added successfully."}}
            }
        case actionTypes.ADD_ACCOUNT_FAILURE:
            return {
                ...state,
                addingPortal: false,
                message: {type: "Error", info: {message: "User account creation failed."}}
            }
        default:
            return {
                ...state
            }
    }
}

export default reducer;